<template>
    <div class="permission-manage">
        <el-card shadow="hover" style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
            <div class="header">
                <h2>用户与权限管理</h2>
                <el-button type="primary" @click="showCreateUserDialog">创建新用户</el-button>
            </div>
            
            <div class="content">
                <div class="search-bar">
                    <el-input 
                        v-model="searchQuery" 
                        placeholder="搜索用户名" 
                        style="width: 300px; margin-bottom: 20px"
                        @keyup.enter.native="handleSearch"
                        clearable
                        @clear="handleSearch">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                    </el-input>
                </div>
                
                <div class="user-list">
                    <el-table 
                        v-loading="loading"
                        :data="userList" 
                        border 
                        style="width: 100%">
                    <el-table-column prop="username" label="用户名" width="180"></el-table-column>
                    <el-table-column prop="role" label="角色" width="150"></el-table-column>
                    <el-table-column label="操作" width="220">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="editPermissions(scope.row)">编辑权限</el-button>
                            <el-button size="mini" type="warning" @click="resetPassword(scope.row)">重置密码</el-button>
                            <el-button size="mini" type="danger" @click="deleteUser(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                    </el-table>
                    
                    <div class="pagination">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pagination.currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pagination.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </el-card>

        <!-- 创建用户弹窗 -->
        <el-dialog title="创建新用户" :visible.sync="createUserDialogVisible" width="30%">
            <el-form :model="newUserForm" label-width="80px">
                <el-form-item label="用户名" prop="username" 
                    :rules="[{ required: true, message: '请输入用户名', trigger: 'blur' }]">
                    <el-input v-model="newUserForm.username"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" 
                    :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
                    <el-input v-model="newUserForm.password" type="password"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="role" 
                    :rules="[{ required: true, message: '请选择角色', trigger: 'change' }]">
                    <el-select v-model="newUserForm.role" placeholder="请选择角色" style="width:100%">
                        <el-option v-for="role in roleOptions" 
                                  :key="role.value"
                                  :label="role.label"
                                  :value="role.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="createUserDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="createUser">确定</el-button>
            </span>
        </el-dialog>

        <!-- 权限配置弹窗 -->
        <el-dialog title="权限配置" :visible.sync="permissionDialogVisible" width="50%">
            <el-form label-width="120px">
                <el-form-item label="当前用户">
                    <span>{{ currentUser.username }}</span>
                </el-form-item>
                <el-form-item label="用户角色">
                    <el-tag type="info">{{ currentUser.role | formatRole }}</el-tag>
                </el-form-item>
                <el-form-item label="权限配置">
                    <div class="permission-container">
                        <el-checkbox-group v-model="currentUser.permissions">
                            <div class="permission-category" v-for="(category, index) in groupedPermissions" :key="index">
                                <h4>{{ category.title }}</h4>
                                <el-checkbox 
                                    v-for="permission in category.permissions" 
                                    :key="permission.value" 
                                    :label="permission.value"
                                    :disabled="permission.required">
                                    {{ permission.label }}
                                    <el-tag v-if="permission.required" type="info" size="mini">默认</el-tag>
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="permissionDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="savePermissions">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
export default {
    name: "PermissionManage",
    data() {
        return {
            userList: [],
            currentUser: {
                id: null,
                username: '',
                permissions: []
            },
            newUserForm: {
                username: '',
                password: ''
            },
            createUserDialogVisible: false,
            permissionDialogVisible: false,
            loading: false,
            searchQuery: '',
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            roleOptions: [
                { value: 'admin', label: '管理员' },
                { value: 'reviewer', label: '审核员' },
                { value: 'operator', label: '操作员' }
            ],
            allPermissions: [
                { value: 'auth-review', label: '企业认证审核' },
                { value: 'data-first-review', label: '数据资产初审' },
                { value: 'data-second-review', label: '数据资产复审' },
                { value: 'data-final-review', label: '数据资产终审' },
                { value: 'auth-query', label: '企业认证信息查询' },
                { value: 'data-public', label: '数据资产公示' },
                { value: 'cert-manage', label: '证书发放管理' }
            ]
        }
    },
    created() {
        this.fetchUserList();
    },
    methods: {
        // 显示创建用户弹窗
        showCreateUserDialog() {
            this.newUserForm = {
                username: '',
                password: ''
            };
            this.createUserDialogVisible = true;
        },
        
        // 获取用户列表
        fetchUserList() {
            this.loading = true;
            const params = {
                page: this.pagination.currentPage,
                size: this.pagination.pageSize,
                keyword: this.searchQuery
            };
            
            this.getRequest('/web/admin/user/list', params).then(res => {
                if (res && res.data) {
                    this.userList = res.data.list || [];
                    this.pagination.total = res.data.total || 0;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        
        // 处理分页大小变化
        handleSizeChange(size) {
            this.pagination.pageSize = size;
            this.fetchUserList();
        },
        
        // 处理当前页变化
        handleCurrentChange(page) {
            this.pagination.currentPage = page;
            this.fetchUserList();
        },
        
        // 处理搜索
        handleSearch() {
            this.pagination.currentPage = 1;
            this.fetchUserList();
        },
        
        // 创建新用户
        createUser() {
            if (!this.newUserForm.username || !this.newUserForm.password) {
                this.$message.error('请输入用户名和密码');
                return;
            }
            
            this.loading = true;
            this.postRequest('/web/admin/user/create', {
                username: this.newUserForm.username,
                password: this.newUserForm.password
            }).then(res => {
                this.$message.success('用户创建成功');
                this.createUserDialogVisible = false;
                this.fetchUserList();
            }).finally(() => {
                this.loading = false;
            });
        },
        
        // 编辑权限
        editPermissions(user) {
            this.currentUser = JSON.parse(JSON.stringify(user));
            this.permissionDialogVisible = true;
        },
        
        // 保存权限配置
        savePermissions() {
            this.loading = true;
            this.postRequest('/web/admin/user/update-permissions', {
                userId: this.currentUser.id,
                permissions: this.currentUser.permissions
            }).then(res => {
                this.$message.success('权限保存成功');
                this.permissionDialogVisible = false;
                this.fetchUserList();
            }).finally(() => {
                this.loading = false;
            });
        },
        
        // 重置密码
        resetPassword(user) {
            this.$prompt('请输入新密码', '重置密码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType: 'password',
                inputValidator: (value) => {
                    if (!value) {
                        return '密码不能为空';
                    }
                    if (value.length < 6) {
                        return '密码长度不能少于6位';
                    }
                }
            }).then(({ value }) => {
                this.loading = true;
                this.postRequest('/web/admin/user/reset-password', {
                    userId: user.id,
                    newPassword: value
                }).then(res => {
                    this.$message.success('密码重置成功');
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {
                this.$message.info('已取消重置密码');
            });
        },
        
        // 删除用户
        deleteUser(user) {
            this.$confirm(`确定要删除用户 ${user.username} 吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                this.postRequest('/web/admin/user/delete', {
                    userId: user.id
                }).then(res => {
                    this.$message.success('用户删除成功');
                    this.fetchUserList();
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        }
    }
}
</script>

<style scoped>
.permission-manage {
    padding: 20px;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.content {
    display: flex;
    margin-top: 20px;
}

.user-list {
    flex: 1;
    margin-right: 20px;
}

.permission-list {
    flex: 1;
    padding: 20px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.permission-item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.permission-item span {
    margin-left: 10px;
}

.el-checkbox-group {
    display: flex;
    flex-direction: column;
}

.el-checkbox {
    margin: 5px 0;
}
</style>